var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c("message-box", {
        attrs: {
          title: "Zrušiť prípad",
          text: "Naozaj chcete zrušiť tento prípad?",
          action: _vm.cancelPripad,
          persistent: "",
          "yes-no": ""
        },
        model: {
          value: _vm.warningMessage.open,
          callback: function($$v) {
            _vm.$set(_vm.warningMessage, "open", $$v)
          },
          expression: "warningMessage.open"
        }
      }),
      _c(
        "div",
        { staticClass: "d-flex my-18px" },
        [
          _c("h2", { staticClass: "noselect" }, [_vm._v("Obchodné prípady")]),
          _c(
            "v-btn",
            {
              staticClass: "btn-primary link ml-auto mr-n3",
              attrs: { to: "/obchodne-pripady", ripple: false }
            },
            [_vm._v("Všetky prípady")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "dash-container-body" },
        [
          !_vm.isLoading
            ? _c(
                "v-row",
                { staticClass: "mx-n4", attrs: { "no-gutters": "" } },
                _vm._l(_vm.data, function(item, index) {
                  return _c(
                    "v-col",
                    {
                      key: index,
                      staticClass: "px-4",
                      attrs: { xl: "3", lg: "3", md: "3" }
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "pa-5 card-item-dark" },
                        [
                          _c(
                            "div",
                            [
                              _c("Status", {
                                staticClass: "mb-3",
                                attrs: { state: item.stav }
                              }),
                              item.rozpracovany
                                ? _c(
                                    "Status",
                                    {
                                      staticClass: "mb-3 right",
                                      attrs: { state: 0 }
                                    },
                                    [_vm._v("Rozpracovaný")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("div", [
                            _c("span", { staticClass: "f12 gs100" }, [
                              _vm._v(
                                _vm._s(item.datum_modifikacie.formatDate())
                              )
                            ]),
                            _c(
                              "span",
                              { staticClass: "f14 bold right mt-3px" },
                              [_vm._v(_vm._s(item.cislo_obch_pripadu))]
                            )
                          ]),
                          _c("text-group", {
                            staticClass: "mt-12px btext-fixed-height",
                            attrs: {
                              utext: "Nájomca",
                              btext: item.najomca,
                              smallHeader: ""
                            }
                          }),
                          _c("v-divider", { staticClass: "my-8px" }),
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c("text-group", {
                                staticClass: "w100",
                                attrs: {
                                  utext: "Modifikoval",
                                  btext: item.modifikoval
                                    ? item.modifikoval
                                    : "-",
                                  smallHeader: ""
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-divider", { staticClass: "my-8px" }),
                          _vm.getMenu(item, "edit_pripad").is_visible
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    top: "",
                                    "close-delay": 0,
                                    "open-delay": 200
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass:
                                                    "mr-3 btn-secondary",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    tile: "",
                                                    outlined: "",
                                                    disabled:
                                                      _vm.getMenu(
                                                        item,
                                                        "edit_pripad"
                                                      ).is_enabled === 0
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.redirectToEditPripad(
                                                        item.new_id
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { size: "18" } },
                                                  [
                                                    _vm._v(
                                                      " mdi-pencil-outline "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getMenu(item, "edit_pripad")
                                          .display_member
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm.getMenu(item, "pridat_dokumenty_pripad")
                            .is_visible
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    top: "",
                                    "close-delay": 0,
                                    "open-delay": 200
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass: "mr-3",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    tile: "",
                                                    disabled:
                                                      _vm.getMenu(
                                                        item,
                                                        "pridat_dokumenty_pripad"
                                                      ).is_enabled === 0
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.redirectToUploadDokumentov(
                                                        item.new_id,
                                                        "0",
                                                        "",
                                                        "dashboard"
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { size: "18" } },
                                                  [
                                                    _vm._v(
                                                      " mdi-upload-outline "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getMenu(
                                          item,
                                          "pridat_dokumenty_pripad"
                                        ).display_member
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm.getMenu(item, "tlacit_pripad").is_visible
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    top: "",
                                    "close-delay": 0,
                                    "open-delay": 200
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass: "mr-3",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    tile: "",
                                                    disabled:
                                                      _vm.getMenu(
                                                        item,
                                                        "tlacit_pripad"
                                                      ).is_enabled === 0
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.redirectToTlacDokumentov(
                                                        item.new_id
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "material-icons-outlined",
                                                    attrs: { size: "18" }
                                                  },
                                                  [_vm._v(" print ")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getMenu(item, "tlacit_pripad")
                                          .display_member
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm.getMenu(item, "sumar").is_visible
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    top: "",
                                    "close-delay": 0,
                                    "open-delay": 200
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass: "mr-3",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    tile: "",
                                                    disabled:
                                                      _vm.getMenu(item, "sumar")
                                                        .is_enabled === 0
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.redirectToSumarPredmet(
                                                        item.new_id
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "material-icons-outlined icon-block",
                                                    attrs: { size: "20" }
                                                  },
                                                  [_vm._v(" summarize ")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getMenu(item, "sumar")
                                          .display_member
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm.getMenu(item, "edit_stav").is_visible
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    top: "",
                                    "close-delay": 0,
                                    "open-delay": 200
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass: "mr-3",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    tile: "",
                                                    disabled:
                                                      _vm.getMenu(
                                                        item,
                                                        "edit_stav"
                                                      ).is_enabled === 0
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openCancelWarning(
                                                        item.new_id
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { size: "18" } },
                                                  [
                                                    _vm._v(
                                                      " mdi-checkbox-blank-circle-outline "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getMenu(item, "edit_stav")
                                          .display_member
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            : _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("v-progress-circular", {
                    attrs: { size: 50, indeterminate: "" }
                  })
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }